<template>
  <div id="app">
    <!-- <transition name="move" mode="out-in"> -->
      <router-view></router-view>
    <!-- </transition> -->
  </div>
</template>

<script>
import storage from '@/assets/js/storage'
export default {
  name: 'app',
  created(){
    if(storage.localGet('user')){
      this.$store.commit('setUserInfo',storage.localGet('user').user)
    }
  },
  watch:{
    $route(to,from){      //登录超时设置
      const userMessage=storage.localGet('user');
      if(userMessage && from.path!='/login' || to.path!='/login'){
        const time=(new Date().getTime()/1000)-userMessage.time;
        if(time>=userMessage.expires){
          this.$confirm('登录超时，请重新登录！', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showCancelButton:false,
            showClose:false,
          }).then(() => {
            storage.localRemove('user')
            this.$router.push('/login');
          })
        }
        if(this.$store.state.login.userinfo['user_id']!=userMessage.user.user_id){    //信息不一致，退出
          this.$router.push('/login');
        }
      }
    }
  },
  components: {
    
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>
